import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent, LabelFieldComponent, LabelTextareaComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { updateAdmin } from "../../APIs/AdminRequests";
import { changePassword, updateUser } from "../../APIs/UserRequests";

export default function MyAccountPage() {

    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState(localStorage.getItem('name'));
    const [email, setEmail] = useState(localStorage.getItem('email'));
    const [bio, setBio] = useState(localStorage.getItem('bio')==='null'?'' : localStorage.getItem('bio'));
    const [status, setStatus] = useState(localStorage.getItem('status')==1?'active':'inactive');
    const [phone, setPhone] = useState(localStorage.getItem('phone')==='null'?'':localStorage.getItem('phone'));
    const [address, setAddress] = useState(localStorage.getItem('address')==='null'?'':localStorage.getItem('address'));
    const [imagePreview, setImagePreview] = useState(localStorage.getItem('image') === ""?'images/avatar/profile.jpg':localStorage.getItem('image'));
    
    const [created_at, setCreated_at] = useState(localStorage.getItem('created_at'));

    const [role, setRole] = useState(localStorage.getItem('role'));
    const [image, setImage] = useState(localStorage.getItem('image') === ""?'images/avatar/profile.jpg':localStorage.getItem('image'));

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    
    // Add password validation states
    const [newPasswordError, setNewPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [currentPasswordError, setCurrentPasswordError] = useState('');

    // Password change handlers with validation
    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        
        // Clear new password error when user types
        if (newPasswordError) {
            setNewPasswordError('');
        }
        
        // Check if confirm password matches the new password
        if (confirmPassword && value !== confirmPassword) {
            setConfirmPasswordError(t('passwords_do_not_match') || 'Passwords do not match');
        } else if (confirmPassword && value === confirmPassword) {
            setConfirmPasswordError('');
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        
        // Clear confirm password error when user types
        if (confirmPasswordError) {
            setConfirmPasswordError('');
        }
        
        // Check if passwords match
        if (newPassword && value !== newPassword) {
            setConfirmPasswordError(t('passwords_do_not_match') || 'Passwords do not match');
        } else if (newPassword && value === newPassword) {
            setConfirmPasswordError('');
        }
    };

    const handleCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
        if (currentPasswordError) {
            setCurrentPasswordError('');
        }
    };

    const updateAdminFunction = () => {
        let statusOption = status == 'active' ? 1 : 0;
        let bioOption= bio == '' ? null: bio;
        let phoneOption =  phone ==''? null:bio;
        let setAddressOption = address ==''? null:address;

        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('bio', bioOption);
        formData.append('status', statusOption);
        formData.append('phone', phoneOption);  
        formData.append('address', setAddressOption);
        if (image instanceof File) {
            formData.append('image', image);
        }
        updateUser(localStorage.getItem('id'),formData).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
            localStorage.setItem('name',name);
            localStorage.setItem('email',email);
            localStorage.setItem('bio',bio);
            // localStorage.setItem('status',statusOption);
            localStorage.setItem('phone',phone);
            localStorage.setItem('address',address);
            localStorage.setItem('image',res.data.data.image);
            // localStorage.setItem('role',role);
        });
    }

    const updatePasswordFunction = () => {
        let hasError = false;
        
        // Clear previous errors
        setCurrentPasswordError('');
        setNewPasswordError('');
        setConfirmPasswordError('');

        // Validate current password
        if (!currentPassword || currentPassword.trim() === '') {
            setCurrentPasswordError(t('current_password_required') || 'Current password is required');
            hasError = true;
        }

        // Validate new password
        if (!newPassword || newPassword.trim() === '') {
            setNewPasswordError(t('new_password_required') || 'New password is required');
            hasError = true;
        } else if (newPassword.length < 6) {
            setNewPasswordError(t('password_min_length') || 'Password must be at least 6 characters');
            hasError = true;
        }

        // Validate confirm password
        if (!confirmPassword || confirmPassword.trim() === '') {
            setConfirmPasswordError(t('confirm_password_required') || 'Please confirm your password');
            hasError = true;
        } else if (newPassword !== confirmPassword) {
            setConfirmPasswordError(t('passwords_do_not_match') || 'Passwords do not match');
            hasError = true;
        }

        if (hasError) {
            toast.error(t('please_fix_errors') || 'Please fix the errors before submitting');
            return;
        }

        changePassword(currentPassword,newPassword,confirmPassword).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        }).catch((error) => {
            console.error('Error changing password:', error);
            toast.error(t('error_changing_password') || 'Error changing password');
        });
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('my_account')}</h3>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" title={t('edit_profile')} className="mc-tabpane profile">
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('public_information')}</h6>
                                    <Row>
                                        <Col xl={4}>
                                            <div className="mc-user-avatar-upload">
                                                <div className="mc-user-avatar">
                                                    <img src={imagePreview} alt="avatar" />
                                                </div>
                                                <FileUploadComponent icon="cloud_upload" text={t('upload')} onChange={(e)=>{
                                                    const file = e.target.files?.[0];
                                                    
                                                    // Validate file size (5MB = 5 * 1024 * 1024 bytes)
                                                    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                                                    
                                                    if (file && file.size > maxSize) {
                                                        toast.error(t('image_size_error') || 'Image size must be less than 5MB');
                                                        // Clear the file input
                                                        e.target.value = '';
                                                        return;
                                                    }
                                                    
                                                    setImage(file);
                                                    if (file) {
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => {
                                                            setImagePreview(reader.result);

                                                        };
                                                        reader.readAsDataURL(file);
                                                    } else {
                                                        setImagePreview(null);
                                                    }
                                                }}/>
                                            </div>
                                        </Col>
                                        <Col xl={8}>
                                            <Row>
                                                <Col xl={12}><LabelFieldComponent type="text" label={t('fullname')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>
                                                
                                                <Col xl={12}><LabelTextareaComponent label={t('biography')} fieldSize="w-100 h-3xl" value={bio} onChange={(e)=> setBio(e.target.value)}/></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('private_information')}</h6>
                                    <Row>
                                        {/* <Col xl={6}><LabelFieldComponent label={t('role')}  fieldSize="w-100 h-md" option={["super admin", "admin", "agent"]} onChange={(e)=> setRole(e.target.value)}/></Col> */}
                                        {/* <Col xl={6}><LabelFieldComponent label={t('status')}  fieldSize="w-100 h-md" option={["active", "inactive"]} onChange={(e)=> setStatus(e.target.value)}/></Col> */}
                                        <Col xl={6}><LabelFieldComponent type="email" label={t('email')}  fieldSize="w-100 h-md" value={email} onChange={(e)=> setEmail(e.target.value)}/></Col>
                                        
                                        <Col xl={6}><LabelFieldComponent type="tel" label={t('phone')}  fieldSize="w-100 h-md" value={phone} onChange={(e)=> setPhone(e.target.value)}/></Col>
                                        <Col xl={6}><LabelFieldComponent type="disabled" label={t('creation date')}  fieldSize="w-100 h-md" value={created_at} disabled/></Col>

                                        <Col xl={12}><LabelTextareaComponent label={t('address')} fieldSize="w-100 h-5xl" value={address} onChange={(e)=> setAddress(e.target.value)}/></Col>
                                    </Row>
                                </div>
                                
                                <ButtonComponent className="mc-btn primary" icon="verified" text={t('save_changes')} onClick={()=>updateAdminFunction()}/>
                            </Tab>
                            <Tab eventKey="password" title={t('change_password')} className="mc-tabpane password">
                                <div className="mc-tab-card">
                                    <h6 className="mc-tab-card-title">{t('generate_password')}</h6>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <IconFieldComponent 
                                                icon="lock" 
                                                type="password" 
                                                placeholder={t('current_password')} 
                                                classes={`w-100 h-lg mb-4 ${currentPasswordError ? 'is-invalid' : ''}`} 
                                                passwordVisible 
                                                value={currentPassword} 
                                                onChange={handleCurrentPasswordChange}
                                            />
                                            {currentPasswordError && (
                                                <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '-15px', marginBottom: '15px' }}>
                                                    <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>
                                                        error
                                                    </i>
                                                    {currentPasswordError}
                                                </div>
                                            )}
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <IconFieldComponent 
                                                icon="add_moderator" 
                                                type="password" 
                                                placeholder={t('new_password')} 
                                                classes={`w-100 h-lg mb-4 ${newPasswordError ? 'is-invalid' : ''}`} 
                                                passwordVisible 
                                                value={newPassword}  
                                                onChange={handleNewPasswordChange}
                                            />
                                            {newPasswordError && (
                                                <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '-15px', marginBottom: '15px' }}>
                                                    <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>
                                                        error
                                                    </i>
                                                    {newPasswordError}
                                                </div>
                                            )}
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <IconFieldComponent 
                                                icon="verified_user" 
                                                type="password" 
                                                placeholder={t('confirm_password')} 
                                                classes={`w-100 h-lg mb-4 ${confirmPasswordError ? 'is-invalid' : ''}`} 
                                                passwordVisible 
                                                value={confirmPassword}  
                                                onChange={handleConfirmPasswordChange}
                                            />
                                            {confirmPasswordError && (
                                                <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '-15px', marginBottom: '15px' }}>
                                                    <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>
                                                        error
                                                    </i>
                                                    {confirmPasswordError}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                                <ButtonComponent className="mc-btn primary" icon="verified" text={t('save_changes')} onClick={()=>updatePasswordFunction()} />
                            </Tab>
                            
                        </Tabs>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}